


import './header.css'

import { useEffect, useState } from "react";
import { useAuth } from '../../AuthContext.js';
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";



const Header =()=>{

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  
    const { isCollapsed,setIsCollapsed } = useAuth();
    
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


    return(
        <div style={{position:'fixed',top:'0px',width:'100%',zIndex:'999'}}>
          <nav>
       
          <ul id="nav-mobile" className="right hide-on-med-and-down">
         
          <li> <img src='./images.jpg' style={{'height':'45px','marginBottom':'10px'}}></img></li>

           
          </ul>
          
          {isMobile &&(<MenuOutlinedIcon  onClick={()=>{setIsCollapsed(!isCollapsed)}} />)}
          </nav>

      </div>
    )
}


export default Header;